import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { delay, Observable, of } from "rxjs";
import { OrderTrackingDto } from "../../model/order-tracking.model";

@Injectable({ providedIn: 'root' })
export class OrderTrackingApi {constructor(
        private _httpClient: HttpClient
    ) {
        
    }

    load(orderCode: string, languageCode: string): Observable<OrderTrackingDto> {
        return this._httpClient
            .get<OrderTrackingDto>(`api/order/tracking/order/${orderCode}/language/${languageCode}`, { withCredentials: true })
    }

    // mockDataDefault: OrderTrackingForData = {
    //     customer: { id: 1, name: "nicolas", surname:"Brillouet", address: { postalCode: '75014'} }, 
    //     order: {id:1}
    // };


}
